<div class="w-100 flex-col" >
  @for(dataSourceEntry of dataSources | keyvalue; track dataSourceEntry.key){
    @if(groupedByContext()){ 
      <div (click)="onGroupingNameClick(dataSourceEntry.key)" class="group-header text-muted">
        <mat-icon class="expansion-icon" [class.expanded]="isDocumentGroupOpened(dataSourceEntry.key)">
          expand_more
        </mat-icon>
        <b>{{dataSourceEntry.key}}</b>
      </div>
    }
    @if(!groupedByContext() || isDocumentGroupOpened(dataSourceEntry.key)){
      <table mat-table [dataSource]="dataSourceEntry.value" matSort #tableSort="matSort" (matSortChange)="assignSort(dataSourceEntry.key, tableSort)" matSortActive="edited" matSortDirection="desc" class="documents-table table-stack-sm w-100" [class]="groupedByContext()?'documents-container-grouped':'documents-container'">
        <ng-container matColumnDef="edited">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Date</th>
          <td mat-cell *matCellDef="let document" > {{document.date | date:'MM/dd/yyyy hh:mm:ss a'}} </td>
        </ng-container>
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="stack-full"> Name</th>
          <td mat-cell *matCellDef="let document" class="stack-full stack-strong">@if(document.isBuyerExecuted){ {{document.userFullName}} } @else{ {{document.name}} }</td>
        </ng-container>
        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="stack-last"> Description</th>
          <td mat-cell *matCellDef="let document" matTooltip="{{document.description}}" class="stack-last" data-label="Description" [class.stack-empty]="!(document.isBuyerExecuted ? document.userName : document.description)">@if(document.isBuyerExecuted){ {{document.userName}} } @else{ {{document.description}} } </td>
        </ng-container>
        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef> Type</th>
          <td mat-cell *matCellDef="let document"> {{(getDocumentType(document) | async)?.name}} </td>
        </ng-container>

        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef class="text-end stack-end"> Actions </th>
          <td mat-cell *matCellDef="let document" class="ws-nowrap text-end stack-end">
            <button mat-icon-button class="primary-color" color="primary" (click)="onViewDocument(document)" [matTooltip]="documentIsRestricted(document)?'Execute Confidentiality Agreement to access document':'View/Download document'">
              <mat-icon >visibility</mat-icon>
            </button>
            @if (!readOnly() && !noEdit(document)) {
              <button mat-icon-button class="primary-color" color="primary" (click)="onEditDocument(document)" matTooltip="Edit document">
                <mat-icon>edit</mat-icon>
              </button>
            }
            @if (!readOnly() && canDelete() && !noEdit(document)) {
              <button mat-icon-button class="warn-color" color="warn" (click)="onDeleteDocument(document)" matTooltip="Delete document">
                <mat-icon>delete</mat-icon>
              </button>
            }
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let document; columns: displayedColumns;"></tr>
      </table>
    }

  }
</div>